import Api from './CustomDashboard.api';
import { UserError } from 'utilities/ErrorHandlling/ErrorHandlling';
import { customDashboardConfigConstants } from './CustomDashboard.constants';
import { message } from 'antd';
import {
  isEmpty as _isEmpty,
  take as _take,
  filter as _filter,
  sortBy as _sortBy,
  forEach as _forEach
} from 'lodash-es';
import { WorkSpaceConstants } from 'redux/WorkSpace/WorkSpace.constants';
import moment from 'moment';
import { t } from 'i18next';

// --- Format :: new API('API URL', 'API SERVICE NAME - from api_service.jsx')
const dashboard = new Api('', 'chart');
const sphere = new Api('chartbuilder', 'sphere');

export const getCustomDashboardConfigs = props => {
  let apiData = {};

  return async dispatch => {
    try {
      dispatch({ type: customDashboardConfigConstants.GET_CHART_QUERY_CONFIGS_REQUEST });
      apiData = await dashboard.getCustomDashboardConfigs(props);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        const { data } = apiData;
        dispatch({ type: customDashboardConfigConstants.GET_CHART_QUERY_CONFIGS_SUCCESS, payload: data });
      }
    } catch (error) {
      dispatch({ type: customDashboardConfigConstants.GET_CHART_QUERY_CONFIGS_ERROR });
      throw new UserError(error);
    }
  };
};

export const getCustomDashboardList = props => {
  let apiData = {};
  return async dispatch => {
    try {
      dispatch({ type: customDashboardConfigConstants.GET_CUSTOM_DASHBOARDS_REQUEST });
      dispatch({ type: WorkSpaceConstants.GET_WORKSPACE_INITIAL_CONFIG_REQUEST });
      apiData = await dashboard.getCustomDashboardList(props);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        const { data } = apiData;
        const { status, ...rest } = data;
        const found =
          _filter(data?.data, dashboard => dashboard?.code === 'custom_dashboard' && !dashboard?.isSharedDashboard) ||
          [];
        dispatch({ type: customDashboardConfigConstants.GET_CUSTOM_DASHBOARDS_SUCCESS, payload: { data: found } });
        dispatch({ type: WorkSpaceConstants.GET_WORKSPACE_INITIAL_CONFIG_SUCCESS, payload: rest });
        const otherThanCustom =
          _filter(
            data?.data,
            dashboard =>
              dashboard?.code !== 'custom_dashboard' && !dashboard?.isSharedDashboard && !dashboard?.is_default
          ) || [];
        const specificObject = _filter(data?.data, dashboard => dashboard?.is_default) || [];
        const sharedDashboards = _sortBy(_filter(data?.data, dashboard => dashboard?.isSharedDashboard) || [], [
          'sequence'
        ]);
        const sortedArray = _sortBy(otherThanCustom, ['sequence']);
        dispatch({
          type: WorkSpaceConstants.UPDATE_ACTIVE_DASHBOARD,
          payload: [...specificObject, ...sortedArray, ...found, ...sharedDashboards] || []
        });
        // --- create applied filters
        let initialAppliedFilters = {};
        if (!_isEmpty(data?.data)) {
          _forEach(data?.data, dashboard => {
            initialAppliedFilters[dashboard?.code] = {
              // date_range:
              //   dashboard?.code === 'finance-ws'
              //     ? [moment().subtract(3, 'w').subtract(3, 'months'), moment().subtract(3, 'w')]
              //     : [moment().subtract(1, 'week'), moment()]
              // selected_stores: []
            };
          });
          dispatch({ type: WorkSpaceConstants.INITIAL_APPLIED_FILTERS, payload: initialAppliedFilters });
        }
      }
    } catch (error) {
      dispatch({ type: customDashboardConfigConstants.GET_CUSTOM_DASHBOARDS_ERROR });
      dispatch({ type: WorkSpaceConstants.GET_WORKSPACE_INITIAL_CONFIG_FAILED });
      throw new UserError(error);
    }
  };
};

export const onCreateCustomDashboard = payload => {
  let apiData = {};
  return async dispatch => {
    try {
      apiData = await dashboard.onCreateCustomDashboard(payload);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        if (!_isEmpty(apiData?.data) && apiData?.status === 200) {
          dispatch(getCustomDashboardList());
          return apiData?.data;
        } else {
          message.error(t('GRAAS_FAILED_TO_CREATE_DASHBOARD_GRAAS'));
        }
      }
    } catch (error) {
      throw new UserError(error);
    }
  };
};

export const getMetricDimensionMapping = loadNewWarehouse => {
  let apiData = {};
  return async dispatch => {
    try {
      dispatch({ type: customDashboardConfigConstants.GET_MAPPING_REQUEST });
      apiData = await dashboard.getMetricDimensionMapping(loadNewWarehouse);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        const { data } = apiData;
        let formattedData = data;
        dispatch({ type: customDashboardConfigConstants.GET_MAPPING_SUCCESS, payload: formattedData });
      }
    } catch (error) {
      dispatch({ type: customDashboardConfigConstants.GET_MAPPING_ERROR });
      throw new UserError(error);
    }
  };
};

export const getMetricDimensionMappingViaSphere = (loadNewWarehouse, channel) => {
  let apiData = {};
  return async dispatch => {
    try {
      dispatch({ type: customDashboardConfigConstants.GET_MAPPING_REQUEST });
      apiData = await sphere.getMetricDimensionMapping(loadNewWarehouse, channel);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        const { data } = apiData;
        let formattedData = data?.data || [];
        dispatch({ type: customDashboardConfigConstants.GET_MAPPING_SUCCESS, payload: formattedData });
      }
    } catch (error) {
      dispatch({ type: customDashboardConfigConstants.GET_MAPPING_ERROR });
      throw new UserError(error);
    }
  };
};

export const onPublishChart = (payload, chartType, navigate, redirectTo = '/analyze/custom-dashboard') => {
  const updatedPayload = { ...payload, chart_type: chartType };
  let apiData = {};
  return async dispatch => {
    try {
      apiData = await dashboard.onPublishChart(updatedPayload);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        message.success(t('GRAAS_CHART_PUBLISHED_SUCCESSFULLY_GRAAS'));
        if (navigate) navigate(redirectTo);
      }
    } catch (error) {
      throw new UserError(error);
    }
  };
};

export const getCustomDashboardDetails = id => {
  let apiData = {};
  return async dispatch => {
    try {
      dispatch({ type: customDashboardConfigConstants.GET_SELECTED_CUSTOM_DASHBOARD_REQUEST });
      apiData = await dashboard.getCustomDashboardDetails(id);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        const { data } = apiData;
        dispatch({ type: customDashboardConfigConstants.GET_SELECTED_CUSTOM_DASHBOARD_SUCCESS, payload: data });
      }
    } catch (error) {
      dispatch({ type: customDashboardConfigConstants.GET_SELECTED_CUSTOM_DASHBOARD_ERROR });
      throw new UserError(error);
    }
  };
};

export const onUpdateCustomDashboard = payload => {
  const { dashboardId, ...rest } = payload;
  let apiData = {};
  return async dispatch => {
    try {
      apiData = await dashboard.onUpdateCustomDashboard(rest, dashboardId);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        message.success(t('GRAAS_DASHBOARD_UPDATED_MSG_GRAAS'));
        dispatch(getCustomDashboardDetails(dashboardId));
      }
    } catch (error) {
      throw new UserError(error);
    }
  };
};

export const onCreateChannelSpecificDashboard = payload => {
  let apiData = {};
  return async dispatch => {
    try {
      apiData = await dashboard.onCreateChannelSpecificDashboard(payload);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        if (!_isEmpty(apiData?.data) && apiData?.status === 200) {
          dispatch(getCustomDashboardList());
        } else {
          message.error(t('GRAAS_FAILED_TO_CREATE_DASHBOARD_GRAAS'));
        }
      }
    } catch (error) {
      throw new UserError(error);
    }
  };
};
